// WP50: applies the chosen theme before first paint (loaded in <head>, not deferred). "system" follows the OS.
const KEY = "dhuwani.theme";

export type Theme = "system" | "light" | "dark";

export function readTheme(): Theme {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(theme: Theme): void {
  if (theme === "system") document.documentElement.removeAttribute("data-theme");
  else document.documentElement.setAttribute("data-theme", theme);
}

export function saveTheme(theme: Theme): void {
  try {
    if (theme === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, theme);
  } catch {
    // private window: the choice lasts for this page only
  }
  applyTheme(theme);
}
